import { Vue } from "vue-property-decorator";
import "reflect-metadata";
//import { notificationMethods } from './store/helpers';
export default class App extends Vue {
}
